if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        const variantInput = this.form?.querySelector("[name=id]");
        if (variantInput) variantInput.disabled = false;
        if (this.form)
          this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        this.submitButton =
          this.submitButton || this.querySelector('[type="submit"]');
        if (
          !this.submitButton ||
          this.submitButton.getAttribute("aria-disabled") === "true"
        )
          return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        const spinner = this.querySelector(".loading-overlay__spinner");
        if (spinner) spinner.classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: "product-form" });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            const btn = this.querySelector('[type="submit"]');
            if (btn) {
              btn.classList.remove("loading");
              if (!this.error) btn.removeAttribute("aria-disabled");
            }
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            const spinner = this.querySelector(".loading-overlay__spinner");
            if (spinner) spinner.classList.add("hidden");
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

const sizeGuidePopup = document.querySelector(".product__size-guide");
const findYourSize = document.querySelector("#find-your-size");
const closeSizeGuideBtn = document.querySelector(".product__size-guide .close");
const sizeGuideBackdrop = document.querySelector(
  ".product__size-guide__backdrop"
);
const htmlTag = document.documentElement;

function openSizeGuide() {
  if (!sizeGuidePopup) return;
  var main = document.querySelector("main#MainContent");
  var lastHeaderSection = main ? main.previousElementSibling : null;
  var topSpacing = lastHeaderSection
    ? Math.ceil(lastHeaderSection.getBoundingClientRect().bottom)
    : 0;
  sizeGuidePopup.style.setProperty(
    "--size-guide-top-spacing",
    topSpacing + "px"
  );
  sizeGuidePopup.classList.add("is-open");
  sizeGuidePopup.setAttribute("aria-hidden", "false");
  htmlTag.classList.add("size-guide-open");
  document.body.addEventListener("keydown", handleSizeGuideEscape);
}

function closeSizeGuide() {
  if (!sizeGuidePopup) return;
  sizeGuidePopup.classList.remove("is-open");
  sizeGuidePopup.setAttribute("aria-hidden", "true");
  htmlTag.classList.remove("size-guide-open");
  document.body.removeEventListener("keydown", handleSizeGuideEscape);
}

function handleSizeGuideEscape(evt) {
  if (evt.key === "Escape") closeSizeGuide();
}

if (findYourSize) {
  findYourSize.addEventListener("click", function (evt) {
    evt.preventDefault();
    openSizeGuide();
  });
}

if (closeSizeGuideBtn) {
  closeSizeGuideBtn.addEventListener("click", function (evt) {
    evt.preventDefault();
    closeSizeGuide();
  });
}

if (sizeGuideBackdrop) {
  sizeGuideBackdrop.addEventListener("click", closeSizeGuide);
}
